import SEO from '@/components/seo/SEO'

/**
 * Stub Términos (D3). Texto legal definitivo lo provee FITLAB (R-408 PRD).
 * SEO D10: title + description + canonical específicos.
 */
export default function Terminos() {
  return (
    <>
      <SEO
        title="Términos de Servicio — FITLAB"
        description="Términos de servicio de FITLAB para el uso del sitio público. Condiciones de uso, limitación de responsabilidad y contacto."
        canonical="https://fitlab.cl/terminos"
      />
      <div className="mx-auto max-w-3xl px-4 pt-32 pb-24 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold tracking-tight text-fitlab-neutral-900 sm:text-5xl">
          Términos de servicio
        </h1>
        <div className="mt-8 space-y-6 text-base leading-relaxed text-fitlab-neutral-600">
          <p>El uso de este sitio web implica aceptación de los términos aquí señalados.</p>
          <p className="italic">
            El texto legal definitivo de los términos será provisto por FITLAB antes de la
            publicación productiva (R-408 PRD F4).
          </p>
        </div>
      </div>
    </>
  )
}
